import { Box } from "@chakra-ui/react";
import React from "react";

export const DOC_TITLES: Record<string, string> = {
  terms_of_service: "Regulamin",
  privacy_policy: "Polityka prywatności",
  accessibility: "Deklaracja dostępności",
  child_safety: "Standardy bezpieczeństwa dzieci"
};

export const DOC_SLUGS: Record<string, string> = {
  terms_of_service: "regulamin",
  privacy_policy: "polityka-prywatnosci",
  accessibility: "deklaracja-dostepnosci",
  child_safety: "standardy-bezpieczenstwa-dzieci"
};

export const SLUG_TO_TYPE: Record<string, string> = Object.fromEntries(
  Object.entries(DOC_SLUGS).map(([type, slug]) => [slug, type])
);

// Renderuje treść HTML dokumentu (autorską, z panelu admina — zaufaną) w czytelnym, ostylowanym bloku.
export const DocumentHtml: React.FC<{ html: string | null }> = ({ html }) => (
  <Box
    fontSize="15px"
    color="gray.700"
    lineHeight="1.7"
    sx={{
      "& h1": { fontSize: "24px", fontWeight: "800", color: "primary", mt: "20px", mb: "10px" },
      "& h2": { fontSize: "19px", fontWeight: "800", color: "primary", mt: "18px", mb: "8px" },
      "& h3": { fontSize: "16px", fontWeight: "700", color: "gray.800", mt: "14px", mb: "6px" },
      "& p": { mb: "10px" },
      "& ul, & ol": { pl: "22px", mb: "10px" },
      "& li": { mb: "4px" },
      "& a": { color: "accent", textDecoration: "underline" },
      "& strong": { fontWeight: "700", color: "gray.800" },
      "& table": { width: "100%", borderCollapse: "collapse", mb: "12px" },
      "& td, & th": { border: "1px solid rgba(67,0,152,0.12)", p: "8px", textAlign: "left" }
    }}
    dangerouslySetInnerHTML={{ __html: html || "<p>Treść dokumentu zostanie wkrótce opublikowana.</p>" }}
  />
);
